import React from 'react';
import * as S from './BalanceCard.styles';
import { BalanceItem } from '@/features/Profile/sections/Balance/api';
import { formatNumber } from '@/utils/helpers';

type BalanceCardProps = Partial<{
  item: BalanceItem;
  isLoading: boolean;
  isTotal: boolean;
  isCount: boolean;
  isInModal: boolean;
}>;

export const BalanceCard = ({
  item,
  isLoading,
  isTotal,
  isCount,
  isInModal,
}: BalanceCardProps) => {
  const { title, subtitle, amount } = item ?? {};

  function formatAmount(value: number | undefined) {
    if (value === undefined) {
      return '';
    }

    if (isCount) {
      return formatNumber(value, 0);
    }

    return `${formatNumber(value, 2)} ₼`;
  }

  if (isLoading) {
    return <S.SkeletonLoader $isTotal={isTotal} $isCount={isCount} />;
  }

  return (
    <S.Card $isTotal={isTotal} $isCount={isCount} $isInModal={isInModal}>
      <S.Header $isInModal={isInModal}>
        <S.Title $isInModal={isInModal}>{title}</S.Title>
        <S.Amount $isCount={isCount} $isInModal={isInModal}>
          {formatAmount(amount)}
        </S.Amount>
      </S.Header>
      <S.Subtitle $isInModal={isInModal}>{subtitle}</S.Subtitle>
    </S.Card>
  );
};
